<template>
    <div class="flex flex-wrap justify-start">
        <portal to="page-header">{{ $t('Games') }}</portal>

        <portal to="actions">
            <div class="flex flex-row-reverse">
                <btn :processing="processing" :type="'button'" v-if="showSave" class="ml-4" @click="save">
                    <span class="hidden sm:inline">{{ $t('Save Changes') }}</span>
                    <span class="sm:hidden md:hidden lg:hidden xl:hidden">{{ $t('Save') }}</span>
                </btn>
            </div>

        </portal>

        <draggable v-model="gamesArray" :options="{
            handle:'.area',
            delay: 200,
            delayOnTouchOnly: true,
            touchStartThreshold: 10,
            animation: 450
        }" group="games" @start="drag=true" @end="drag=false" class="flex flex-wrap">
            <div v-for="(game, index) in gamesArray" :key="game.id" class="md:px-3 lg:px-3 xl:px-3 mb-1 sm:mb-1 md:mb-3 lg:mb-3 xl:mb-3 w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
                <card class="flex justify-between">
                    <div class="flex justify-start text-lg font-bold align-middle h-full area cursor-pointer">
                        <div class="my-3 mr-2 text-gray-400">
                            <font-awesome-icon icon="grip-lines-vertical" />
                        </div>
                        <div class="my-3 mr-2 no-select">
                            {{game.name}} <span class="text-gray-500">#{{index}}</span>
                        </div>
                    </div>
                    <div class="flex justify-end align-middle text-right h-auto">
                        <div class="my-3 mr-2">
                            <toggle-button v-model="game.pivot.active" />
                        </div>
                        <div>
                            <img :alt="game.name" :src="game.imageUrl">
                        </div>
                    </div>
                </card>
            </div>
        </draggable>
    </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';
import draggable from 'vuedraggable';
import Card from '../Components/Card';
import Btn from '../Components/Btn';

export default {
    name: "Games",
    components: { ToggleButton, draggable, Card, Btn },
    props: ['games'],
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        title () {
            return this.$t('Games');
        },
    },
    data: () => ({
        gamesArray: [],
        changesCounter: 0,
        showSave: false,
        processing: false
    }),
    mounted() {
        this.gamesArray = this.games;
    },
    methods: {
        async save() {
            this.processing = true;
            await this.$inertia.post(route('pos.storeGames').url(), {
                games: this.gamesArray
            });
            this.processing = false;
            this.changesCounter = 1;
            this.showSave = false;
        }
    },
    watch: {
        gamesArray: {
            handler: function() {
                this.changesCounter++;
                if (this.changesCounter > 1) {
                    this.showSave = true;
                }
            },
            deep: true,
        },
    },
}
</script>
<style lang="scss" scoped>
img, video {
    max-height: 50px;
}
.no-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.sortable-ghost {
    opacity: 0.1;
}
</style>
